import React from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import styled from 'styled-components';
import {
  HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalExaminationDto,
  HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalExaminationResourceDto,
} from '@sdir/httpclient/lib/clients/aps/health';

type EvaluationListProps = {
  isOldHealthcheck?: boolean;
  labels?: HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalExaminationResourceDto;
  examination?: HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalExaminationDto | null;
};

const EvaluationList: React.FC<EvaluationListProps> = ({
  isOldHealthcheck = false,
  labels,
  examination,
}) => {
  const intl = useIntl();

  return (
    <Content>
      <Row>
        <div>{labels?.hearingMeetsStandardLabel || ''}</div>
        <div>
          {examination?.hearingMeetsStandard
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.hearingUnaidedSatisfactoryLabel || ''}</div>
        <div>
          {examination?.hearingUnaidedSatisfactory
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.visionMeetsStandardLabel || ''}</div>
        <div>
          {examination?.visionMeetsStandard
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.visualAidNeededLabel || ''}</div>
        {isOldHealthcheck ? (
          <div>N/A</div>
        ) : (
          <div>
            {examination?.visualAidNeeded
              ? intl.formatMessage({ id: 'general.yes' })
              : intl.formatMessage({ id: 'general.no' })}
          </div>
        )}
      </Row>
      <Row>
        <div>{labels?.colorVisionMeetsStandardLabel || ''}</div>
        <div>
          {examination?.colorVisionMeetsStandard
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.colorVisionTestDateLabel || ''}</div>
        <div>
          {examination?.colorVisionTestDate
            ? moment(examination.colorVisionTestDate).format('DD.MM.YYYY')
            : '-'}
        </div>
      </Row>
      <Row>
        <div>{labels?.fitForLookoutDutiesLabel || ''}</div>
        <div>
          {examination?.fitForLookoutDuties
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.fitForSafetyDutiesLabel || ''}</div>
        <div>
          {examination?.fitForSafetyDuties
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.medicallySafeForServiceLabel || ''}</div>
        <div>
          {examination?.medicallySafeForService
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
      <Row>
        <div>{labels?.noFitnessLimitationsLabel || ''}</div>
        <div>
          {examination?.noFitnessLimitations
            ? intl.formatMessage({ id: 'general.yes' })
            : intl.formatMessage({ id: 'general.no' })}
        </div>
      </Row>
    </Content>
  );
};

export default EvaluationList;

const Content = styled.div``;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0;

  & > div {
    &:first-child {
      padding-right: 10px;
      text-align: left;
    }
    &:last-child {
      min-width: 100px;
    }
  }
`;
